import React, { useEffect, useMemo, useState } from 'react';
import { Languages } from '../../models/translations';
import { LanguageContext } from './context';
import { supportedLanguages, translations } from './i18n';
import { resolveLanguage, storeLanguage } from './language-storage';
import { NikeI18nProvider } from '@nike/i18n-react';


export const Language: React.FC<{ children: React.ReactElement }> = ({ children }) => {
    const [language, setLanguage] = useState<Languages>(resolveLanguage);

    useEffect(() => {
        storeLanguage(language);
    }, [language]);

    return (
        <LanguageContext.Provider value={useMemo(() => [language, setLanguage], [language])}>
            <NikeI18nProvider currentLanguageTag={language} supportedLanguages={supportedLanguages} translations={translations}>
               {children}
            </NikeI18nProvider>
        </LanguageContext.Provider>
    );
};
